import { showAlert } from "@components/alert/action";
import PropTypes from "prop-types";
import React, { memo, useCallback, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";
import { BettoPrimaryButton } from "../BettoButton";

const Root = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

const Status = styled.p`
	margin: 0;
	color: ${({ $active }) =>
		$active ? BTTO_PROFILE_COLORS.success : BTTO_PROFILE_COLORS.warning};
	font-size: 14px;
	font-weight: 600;
`;

const Description = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 13px;
	line-height: 1.5;
`;

export const BettoRealityCheck = memo(({ translate, showAlert }) => {
	const [active, setActive] = useState(
		() => localStorage.getItem("realityCheck.active") === "true"
	);

	const handleToggle = useCallback(() => {
		const nextActive = !active;
		localStorage.setItem("realityCheck.active", nextActive ? "true" : "false");
		setActive(nextActive);
		showAlert({
			type: nextActive ? "success" : "error",
			msg: nextActive ? translate("realityCheck.enable") : translate("realityCheck.disabled"),
			noTranslate: true,
		});
	}, [active, showAlert, translate]);

	return (
		<Root>
			<Status $active={active}>
				{active ? translate("realityCheck.enable") : translate("realityCheck.disable")}
			</Status>
			<Description>{translate("realityCheck.profileDescription")}</Description>
			<BettoPrimaryButton
				variant={active ? "secondary" : "primary"}
				onClick={handleToggle}>
				{translate(active ? "realityCheck.disableBtn" : "realityCheck.enableBtn")}
			</BettoPrimaryButton>
		</Root>
	);
});

BettoRealityCheck.displayName = "BettoRealityCheck";

BettoRealityCheck.propTypes = {
	translate: PropTypes.func.isRequired,
	showAlert: PropTypes.func,
};

const mapDispatchToProps = { showAlert };

export default connect(null, mapDispatchToProps)(BettoRealityCheck);
